import VasundaraDevi from "../assets/testimonials/vasundara_devi.png";
import AshutoshVerma from "../assets/testimonials/ashutosh_verma.png";
import AaradhyaParsodiya from "../assets/testimonials/aaradhya_parsodiya.png";
import JheelGupta from "../assets/testimonials/jheel_gupta.png";
import PriyadarshanJain from "../assets/testimonials/priyadarshan_jain.png";
import AryanAgrawal from "../assets/testimonials/aryan_agrawal.png";
import NidhulSasi from "../assets/testimonials/nidhul_sasi.png";

export const testimonials = [
    {
      fields: {
        rating: 4,
        content: "I am writing to express my heartfelt appreciation for the incredible opportunity to work as a UI/UX Design Intern at Mentorsity. This internship has been a highly enriching experience, allowing me to grow both personally and professionally.The work culture at Mentorsity is truly supportive, encouraging innovation and continuous learning. I was able to gain hands-on experience in various stages of the design process—from user research and wireframing to prototyping and usability testing.I am grateful for the trust and responsibilities given to me during the internship. It has strengthened my confidence as a budding UI/UX designer and motivated me to continue exploring this dynamic field with greater passion.",
        url: VasundaraDevi,
        name: "Vasundara Devi .V",
        designation: "UI/UX Designer",
      },
    },
    {
      fields: {
        rating: 5,
        content: "I completed a 4-month Graphic Design Internship at Mentorsity, and it turned out to be a very valuable experience. The tasks assigned were practical and helped me enhance my creative and professional skills. The mentorship was consistent and supportive throughout the journey, and I truly appreciated the flexibility and learning opportunities provided. It was a smooth and meaningful experience that contributed to my growth as a designer.",
        url: AshutoshVerma,
        name: "Ashutosh Raj Verma",
        designation: "Graphic Designer",
      },
    },
    {
      fields: {
        rating: 4,
        content: "Hey everyone, I started my internship at Mentorsity as a backend developer intern, where my journey was as exciting as I thought it would be, such as getting constant support and guidance from the seniors and doing the tasks that contain a sense of responsibility, like performing a task that is going to impact the real users. Throughout the duration, the whole team provided a very happy environment for doing the work by maintaining the work-life balance and flexible work schedule.",
        url: AaradhyaParsodiya,
        name: "Aaradhya Parsodia",
        designation: "Backend Developer",
      },
    },
    {
      fields: {
        rating: 4,
        content: "Absolutely loved working at Mentorsity as an Operations Intern. I had a great experience and I got to learn a lot of things. Riya Ma’am and Jindal sir are truly helpful in nature and they guided us through all ups and downs of the project. As an intern, I loved the corporate experience I had at Mentorsity, within these 4 months and would recommend everyone out there to join Mentorsity‘s Internship Programme",
        url: JheelGupta,
        name: "Jheel Gupta",
        designation: "Operations Intern",
      },
    },
    {
      fields: {
        rating: 4,
        content: "Working at Mentorsity was an appreciable learning experience. Being drafted into the program management team, I had the privilege of having close communications with the Co-founder himself with regards to the program which we were asked to work on. It's rare to find a firm which gives you this exposure. So, a big thank you to Mentorsity for this.",
        url: PriyadarshanJain,
        name: "Priyadarshan Jain",
        designation: "Developer",
      },
    },
    {
      fields: {
        rating: 4,
        content: "Best experience! My 5 months as Product Manager here fly away quickly in the Learning, growthfull and collaborative environment of the company.",
        url: AryanAgrawal,
        name: "Aryan Agrawal",
        designation: "Product Manager",
      },
    },
    {
      fields: {
        rating: 4,
        content: "Excellent mentorship and working environment.",
        url: NidhulSasi,
        name: "Nidhul K Sasi",
        designation: "Developer",
      },
    }
  ]